import React from "react";

import { Route, Routes } from "react-router-dom";

import { useDisclosure } from "@chakra-ui/react";

import Navbar from "components/Navbars/Navbar";
import SidebarTW from "components/Sidebar/SidebarTW";

import dynamicRoutes from "dynamicRoutes.js";
import SidebarModal from "components/SidebarModal/SidebarModal";

function Dashboard(props) {
  const routes = dynamicRoutes["admin"];

  const [backgroundColor, setBackgroundColor] = React.useState("black");
  const [activeColor, setActiveColor] = React.useState("info");

  const { isOpen, onOpen, onClose } = useDisclosure();

  const openSmallSidebar = () => {
    onOpen();
  };

  return (
    <div className="w-screen  ">
      <SidebarModal
        isOpen={isOpen}
        onClose={onClose}
        routes={routes}
        mode={"admin"}
      />
      <Navbar
        {...props}
        className="z-50"
        openSmallSidebar={openSmallSidebar}
        mode={"admin"}
      />
      <div className="w-full h-full flex flex-row  ">
        <SidebarTW
          {...props}
          routes={routes}
          bgColor={backgroundColor}
          activeColor={activeColor}
          mode={"admin"}
        />
        <div
          style={{ height: "calc(100vh - 4rem)" }}
          className="w-full  ml-2 lg:ml-6 pt-6  overflow-y-auto  pr-2 lg:pr-12  "
        >
          <Routes>
            {routes.map((prop, key) => {
              return (
                <Route
                  path={prop.path}
                  element={prop.component}
                  key={key}
                  exact
                />
              );
            })}
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
